import filters from '@/filters/filters'
import {getSummarySimpleTable, getPaymentsConfigTable, getModificationCostProject, getSubcontractSummarySimpleTable, getSubcontractPaymentsTotalsTable, getSubContractBankAccountHtml, validatePaymentsFullyCovered} from '@/helpers/tablecostHelpers'

export const contractStatuses = {
	CREADO: 1,
	ESPERANDO_PAGO: 2,
	PAGADO: 3,
	ESPERANDO_EMPRESA: 4,
	VISTO_BUENO_EMPRESA: 5,
	ENVIADO_CONTRAPARTE: 6,
	OBSERVADO_CONTRAPARTE: 7,
	ACEPTADO: 8,
	RECHAZADO: 9,
	FIRMADO_CONTRAPARTE: 10,
	FIRMADO_AMBAS_PARTES: 11,
	SUBCONTRATO_ANULADO: 12,
};

export const placeholderMapping = {
  // Fechas
  '{contract_date}': 'Fecha del Contrato',
  '{contract_start_date}': 'Fecha Inicio',

  // Proyecto
  '{project_name}': 'Nombre del Proyecto',
  '{project_address}': 'Dirección del Proyecto',
  '{project_district}': 'Comuna del Proyecto',
  '{project_type}': 'Tipo de Proyecto',
  '{project_serial_number}': 'Número de Serie del Proyecto',
  '{project_zone}': 'Zona del Proyecto',
  '{project_responsible_name}': 'Nombre Responsable del Proyecto',
  '{project_responsible_email}': 'Email Responsable del Proyecto',
  '{project_responsible_phone}': 'Teléfono Responsable del Proyecto',

  // Empresa ejecutora
  '{company_name}': 'Nombre Empresa',
  '{company_rut}': 'Rut Empresa',
  '{company_responsible}': 'Nombre Representante',
  '{company_responsible_rut}': 'Rut Representante',
  '{company_address}': 'Dirección Empresa',
	'{company_bank_account_html}': 'Cuenta Bancaria Empresa',

  // Cliente
  '{client_name}': 'Nombre Cliente',
  '{client_email}': 'Email Cliente',
  '{client_dni}': 'Rut Cliente',
  '{client_phone}': 'Teléfono Cliente',
  '{client_address}': 'Dirección Cliente',
  '{client_district}': 'Comuna Cliente',

  // Empresa del cliente (opcional)
  '{client_company_name}': 'Nombre Empresa (Cliente)',
  '{client_company_dni}': 'Rut Empresa (Cliente)',
  '{client_company_address}': 'Dirección Empresa (Cliente)',
  '{client_company_district}': 'Comuna Empresa (Cliente)',
  '{client_rep_name}': 'Nombre Representante (Cliente)',
  '{client_rep_dni}': 'Rut Representante (Cliente)',
  '{client_rep_address}': 'Dirección Representante (Cliente)',
  '{client_rep_district}': 'Comuna Representante (Cliente)',

  // Proveedor / Subcontratista
  '{contractor_name}': 'Nombre Subcontratista',
  '{contractor_email}': 'Email Subcontratista',
  '{contractor_dni}': 'Rut Subcontratista',
  '{contractor_phone}': 'Teléfono Subcontratista',
  '{contractor_address}': 'Dirección Subcontratista',
  '{contractor_district}': 'Comuna Subcontratista',

  // Empresa del Proveedor / Subcontratista (opcional)
  '{contractor_company_name}': 'Nombre Empresa (Subcontratista)',
  '{contractor_company_dni}': 'Rut Empresa (Subcontratista)',
  '{contractor_company_address}': 'Dirección Empresa (Subcontratista)',
  '{contractor_company_district}': 'Comuna Empresa (Subcontratista)',
  '{contractor_rep_name}': 'Nombre Representante (Subcontratista)',
  '{contractor_rep_dni}': 'Rut Representante (Subcontratista)',
  '{contractor_rep_address}': 'Dirección Representante (Subcontratista)',
	'{subcontract_bank_account_html}': 'Cuenta Bancaria Subcontratista',

	// Tabla de costo
	'{cost_table_summary}': 'Resumen Tabla de Costos del Contrato',
	'{cost_table_payments}': 'Etapas y Pagos del Contrato',
	'{cost_table_subcontract_summary}': 'Resumen Tabla de Costos del Subcontrato',
	'{cost_table_subcontract_payments}': 'Etapas y Pagos del Subcontrato',
	'{posible_stages_list}': 'Posibles etapas a incluir en el proyecto',

	// Project variables (Otros)
	'{project_modification_value_uf}': 'Costo Modificación Proyecto UF',
	'{project_modification_value_clp}': 'Costo Modificación Proyecto CLP',
};

export function getContractContext(contract){
	const company_bank_account_html = contract.morphable?.company?.bank_account
		? `<div id="{company_bank_account_html}"><p><b>Banco:</b> ${contract.morphable.company.bank_account.bank_name}</p>
			 <p><b>Tipo de Cuenta:</b> ${contract.morphable.company.bank_account.account_type}</p>
			 <p><b>Número de Cuenta:</b> ${contract.morphable.company.bank_account.account_number}</p>
			 <p><b>Nombre Titular:</b> ${contract.morphable.company.bank_account.account_holder_name}</p>
			 <p><b>Rut Titular:</b> ${filters.formatRut(contract.morphable.company.bank_account.account_holder_rut)}</p></div>`
		: 'N/A';
	return {
		// Fechas
		'{contract_date}': filters.toDate(contract.created_at),
		'{contract_start_date}': contract.start_date ? filters.toDate(contract.start_date) : 'A Convenir',

		// Proyecto
		'{project_name}': contract.morphable?.name ?? 'Sin Detalle',
		'{project_address}': contract.morphable?.info?.address?.address ?? '--',
		'{project_district}': contract.morphable?.info?.address?.district?.name ?? '--',
		'{project_type}': contract.morphable?.info?.project_type?.name ?? '--',
		// '{project_serial_number}': contract.morphable?.info?.serial_number ?? 'N/A',
		'{project_zone}': contract.morphable?.info?.zone?.name ?? '--',
		'{project_responsible_name}': `${contract.morphable?.responsible?.profile?.name} ${contract.morphable?.responsible?.profile?.lastname} ${contract.morphable?.responsible?.profile?.second_lastname}`,
		'{project_responsible_email}': contract.morphable?.responsible?.email ?? 'N/A',
		'{project_responsible_phone}': contract.morphable?.responsible?.profile?.phone ?? 'N/A',

		// Empresa ejecutora
		'{company_name}': contract.morphable?.company?.name ?? 'N/A',
		'{company_rut}': filters.formatRut(contract.morphable?.company?.rut ?? ''),
		'{company_responsible}': `${contract.morphable?.company?.user_responsible?.profile?.name} ${contract.morphable?.company?.user_responsible?.profile?.lastname} ${contract.morphable?.company?.user_responsible?.profile?.second_lastname}`,
		'{company_responsible_rut}': filters.formatRut(contract.morphable?.company?.user_responsible?.profile?.rut ?? ''),
		'{company_address}': contract.morphable?.company?.address ?? 'N/A',
		'{company_bank_account_html}': company_bank_account_html,

		// Cliente
		'{client_name}': `${contract.morphable?.client?.profile?.name} ${contract.morphable?.client?.profile?.lastname} ${contract.morphable?.client?.profile?.second_lastname}`,
		'{client_email}': contract.morphable?.client?.email ?? 'N/A',
		'{client_dni}': filters.formatRut(contract.morphable?.client?.profile?.rut ?? ''),
		'{client_phone}': contract.morphable?.client?.profile?.phone ?? 'N/A',
		'{client_address}': contract.morphable?.client?.profile?.address ?? 'N/A',
		'{client_district}': contract.morphable?.client?.profile?.city?.name ?? 'N/A',

		// Empresa del cliente (opcional)
		'{client_company_name}': contract.morphable?.client?.company_profile?.name ?? 'N/A sss',
		'{client_company_dni}': filters.formatRut(contract.morphable?.client?.company_profile?.rut ?? ''),
		'{client_company_address}': contract.morphable?.client?.company_profile?.address ?? 'N/A',
		'{client_company_district}': contract.morphable?.client?.company_profile?.city?.name ?? 'N/A',
		'{client_rep_name}': `${contract.morphable?.client?.company_profile?.rep_name ?? ''} ${contract.morphable?.client?.company_profile?.rep_first_lastname ?? ''} ${contract.morphable?.client?.company_profile?.rep_second_lastname ?? ''}`.trim(),
		'{client_rep_dni}': filters.formatRut(contract.morphable?.client?.company_profile?.rep_rut ?? ''),
		'{client_rep_address}': contract.morphable?.client?.company_profile?.rep_address ?? 'N/A',
		'{client_rep_district}': contract.morphable?.client?.company_profile?.rep_city?.name ?? 'N/A',

		// Proveedor / Subcontratista
		'{contractor_name}': `${contract.contractor?.profile?.name ?? ''} ${contract.contractor?.profile?.lastname ?? ''} ${contract.contractor?.profile?.second_lastname ?? ''}`.trim(),
		'{contractor_email}': contract.contractor?.email ?? 'N/A',
		'{contractor_dni}': filters.formatRut(contract.contractor?.profile?.rut ?? ''),
		'{contractor_phone}': contract.contractor?.profile?.phone ?? 'N/A',
		'{contractor_address}': contract.contractor?.profile?.address ?? 'N/A',
		'{contractor_district}': contract.contractor?.profile?.city?.name ?? 'N/A',

		// Empresa del Proveedor / Subcontratista (opcional)
		'{contractor_company_name}': contract.contractor?.company_profile?.name ?? 'N/A',
		'{contractor_company_dni}': filters.formatRut(contract.contractor?.company_profile?.rut ?? ''),
		'{contractor_company_address}': contract.contractor?.company_profile?.address ?? 'N/A',
		'{contractor_company_district}': contract.contractor?.company_profile?.city?.name ?? 'N/A',
		'{contractor_rep_name}': `${contract.contractor?.company_profile?.rep_name ?? ''} ${contract.contractor?.company_profile?.rep_first_lastname ?? ''} ${contract.contractor?.company_profile?.rep_second_lastname ?? ''}`.trim(),
		'{contractor_rep_dni}': filters.formatRut(contract.contractor?.company_profile?.rep_rut ?? ''),
		'{contractor_rep_address}': contract.contractor?.company_profile?.rep_address ?? 'N/A',

		// Tabla de costo
		'{cost_table_summary}': getSummarySimpleTable(contract),
		'{cost_table_payments}': getPaymentsConfigTable(contract),
		'{cost_table_subcontract_summary}': getSubcontractSummarySimpleTable(contract),
		'{cost_table_subcontract_payments}': getSubcontractPaymentsTotalsTable(contract),
		'{subcontract_bank_account_html}': getSubContractBankAccountHtml(contract),
		'{posible_stages_list}': getContractPosibleStagesList(contract),

		// Campos legacy (mantener por compatibilidad si es necesario)
		'{address}': contract.morphable?.info?.address?.address ?? '--',
		'{district}': contract.morphable?.info?.address?.district?.name ?? '--',

		'{project_modification_value_uf}': getModificationCostProject(contract).uf + 'UF',
		'{project_modification_value_clp}': '$' + getModificationCostProject(contract).clp,
	}
}

export function transformPlaceholdersToRealContent(contract, content, showButtons = false) {
	const parser = new DOMParser();
	const doc = parser.parseFromString(content, 'text/html');

	const documentVariablesValue = getContractContext(contract);

	const withNoWrapper = [
		'{company_bank_account_html}',
		'{subcontract_bank_account_html}',
		'{cost_table_summary}',
		'{cost_table_payments}',
		'{cost_table_subcontract_summary}',
		'{cost_table_subcontract_payments}',
		'{posible_stages_list}'
	];

	const walker = doc.createTreeWalker(
		doc.body,
		NodeFilter.SHOW_TEXT,
		null,
		false
	);

	const nodesToReplace = [];

	let textNode;
	while ((textNode = walker.nextNode())) {
		for (const placeholder of Object.keys(documentVariablesValue)) {
			if (textNode.nodeValue.includes(placeholder)) {
				nodesToReplace.push(textNode);
				break;
			}
		}
	}

	nodesToReplace.forEach(textNode => {
		if (!textNode.parentNode) return;

		let newContent = textNode.nodeValue;

		for (const [placeholder, label] of Object.entries(documentVariablesValue)) {
			if (newContent.includes(placeholder)) {

				if (withNoWrapper.includes(placeholder)) {
					newContent = newContent.replaceAll(placeholder, label);
				} else {
					newContent = newContent.replaceAll(
						placeholder,
						`<b><span id="${placeholder}">${label}</span></b>`
					);
				}
			}
		}

		const temp = doc.createElement('div');
		temp.innerHTML = newContent;

		const fragment = doc.createDocumentFragment();
		while (temp.firstChild) {
			fragment.appendChild(temp.firstChild);
		}

		textNode.parentNode.replaceChild(fragment, textNode);
	});

	if (!showButtons) {
		doc.querySelectorAll('#edit-payments-btn-container').forEach(el => el.remove());
		doc.querySelectorAll('#edit-subcontract-payments-btn-container').forEach(el => el.remove());
	}

	return doc.body.innerHTML;
}

export function reverseContentToPlaceholders(content) {
	const parser = new DOMParser();
	const doc = parser.parseFromString(content, 'text/html');

	const elementsWithId = doc.querySelectorAll('[id]');

	elementsWithId.forEach(el => {
		if (/^\{.*\}$/.test(el.id)) {
			const textNode = doc.createTextNode(el.id);
			el.replaceWith(textNode);
		}
	});

	return doc.body.innerHTML;
}

export function isContractTableCostComplete(costsTable, contract) {
	let finalCostsTable = costsTable;
	if(!costsTable){
		finalCostsTable = contract.cost_table
	}
	if(!finalCostsTable) return false;
	const verification_result = validatePaymentsFullyCovered(finalCostsTable);
	return verification_result;
}

export function getContractPosibleStagesList(contract){
	let finalCostsTable = contract.cost_table;
	if(!finalCostsTable) return '';
	
	const stageNames = finalCostsTable.stages
		.filter(stage => !stage.active)
		.map(stage => stage.stage?.name)
		.filter(name => !!name);
	
	if (!stageNames.length) return '';
	
	return `<div id="{posible_stages_list}"><ul>${stageNames.map(name => `<li><b>${name}</b></li>`).join('')}</ul></div>`;
}

export default contractStatuses;